export default {
    GET_PROOF_JOBS_REQUEST: state => {
        state.jobsForProofLoading = true
    },
    GET_PROOF_JOBS_SUCCESS: (state, data) => {
        state.jobsForProof = data.results
        state.jobsForProofLoading = false
    },
    GET_PROOF_JOBS_FAILURE: state => {
        state.jobsForProofLoading = false
    },
}
